import { session } from "./storage";
import { getAnonymousId } from "./identity";
import { getActiveUtm, getFirstTouchUtm } from "./utm";
import type { UtmParams } from "./types";

const LANDING_KEY = "amz_landing_page";

/**
 * The path the miniapp was opened at this launch. Captured once per cold launch
 * (in initAnalytics) so it survives in-app navigation and is available for the
 * login/callback body.
 */
export const captureLandingPage = (): void => {
  if (typeof window === "undefined") return;
  if (session.get(LANDING_KEY)) return;
  session.set(LANDING_KEY, window.location.pathname + window.location.search);
};

export const getLandingPage = (): string | undefined =>
  session.get(LANDING_KEY) ?? undefined;

export interface SignupAttribution extends UtmParams {
  anonymous_id: string;
  landing_page?: string;
}

/**
 * Fields to merge into the signup/login call (`auth/jwt/callback`). UTMs here
 * come from FIRST-TOUCH (`amz_utm_first`) — the campaign that originally
 * acquired the user — never the active launch UTM.
 */
export const getSignupAttribution = (): SignupAttribution => ({
  anonymous_id: getAnonymousId(),
  landing_page: getLandingPage(),
  ...getFirstTouchUtm(),
});

/**
 * Fields to merge into the buy/checkout call. UTMs here are the ACTIVE
 * (last-touch) launch UTM and are omitted entirely on an organic launch — the
 * backend stores exactly what it receives and never falls back to old events.
 */
export const getBuyAttribution = (): UtmParams => getActiveUtm();
